import { render, staticRenderFns } from "./AlternativesViewDependenciesDialog.vue?vue&type=template&id=4782f862"
import script from "./AlternativesViewDependenciesDialog.vue?vue&type=script&lang=ts"
export * from "./AlternativesViewDependenciesDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports